var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchool1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M594 673L594 701",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 594.5,
    cy: 668.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M594 677L587 673.2V667.2L583 665L594 659L605 665V673H603V666.1L601 667.2V673.2L594 677ZM594 668.7L600.85 665L594 661.3L587.15 665L594 668.7ZM594 674.725L599 672.025V668.25L594 671L589 668.25V672.025L594 674.725Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool1);
export default __webpack_public_path__ + "static/media/school_1.6c9be65f6940428cf1b780ea5f9cae9b.svg";
export { ForwardRef as ReactComponent };